'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PagerDefault = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('../utils');

var _rpReactSvgIcon = require('rp-react-svg-icon');

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _PageLink = require('./PageLink');

var _PageLink2 = _interopRequireDefault(_PageLink);

var _actions = require('../actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pager = function (_Component) {
    _inherits(Pager, _Component);

    _createClass(Pager, null, [{
        key: 'renderArrow',
        value: function renderArrow(onClick, disabled, child) {
            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)('ui-btn', { 'ui-btn--disabled': disabled }),
                    onClick: onClick
                },
                child
            );
        }
    }]);

    function Pager(props) {
        _classCallCheck(this, Pager);

        var _this = _possibleConstructorReturn(this, (Pager.__proto__ || Object.getPrototypeOf(Pager)).call(this, props));

        _this.onNavigateLeftClick = _this.onNavigateLeftClick.bind(_this);
        _this.onNavigateRightClick = _this.onNavigateRightClick.bind(_this);
        _this.onLeftClick = _this.onLeftClick.bind(_this);
        _this.onRightClick = _this.onRightClick.bind(_this);
        return _this;
    }

    _createClass(Pager, [{
        key: 'onNavigateLeftClick',
        value: function onNavigateLeftClick() {
            var _props = this.props,
                onOffsetChange = _props.onOffsetChange,
                offsetRange = _props.offsetRange,
                pagerLength = _props.pagerLength;

            return onOffsetChange(-1 * offsetRange, pagerLength);
        }
    }, {
        key: 'onNavigateRightClick',
        value: function onNavigateRightClick() {
            var _props2 = this.props,
                onOffsetChange = _props2.onOffsetChange,
                offsetRange = _props2.offsetRange,
                pagerLength = _props2.pagerLength;

            return onOffsetChange(offsetRange, pagerLength);
        }
    }, {
        key: 'onLeftClick',
        value: function onLeftClick() {
            var _props3 = this.props,
                currentPage = _props3.currentPage,
                onPageChange = _props3.onPageChange;

            return currentPage > 1 ? onPageChange(currentPage - 1, this.props) : false;
        }
    }, {
        key: 'onRightClick',
        value: function onRightClick() {
            var _props4 = this.props,
                currentPage = _props4.currentPage,
                totalPages = _props4.totalPages,
                onPageChange = _props4.onPageChange;

            return currentPage < totalPages ? onPageChange(currentPage + 1, this.props) : false;
        }
    }, {
        key: 'getPageLabel',
        value: function getPageLabel(page) {
            var customLabel = this.getCustomLabel(page);
            return !customLabel ? page : customLabel;
        }
    }, {
        key: 'getCurrentPageLabel',
        value: function getCurrentPageLabel() {
            var _props5 = this.props,
                currentPage = _props5.currentPage,
                totalPages = _props5.totalPages;

            var customLabel = this.getCustomLabel(currentPage);
            return !customLabel ? 'Page ' + currentPage + ' of ' + totalPages : customLabel;
        }
    }, {
        key: 'getCustomLabel',
        value: function getCustomLabel(page) {
            var _props6 = this.props,
                customLabels = _props6.customLabels,
                showItemsRange = _props6.showItemsRange;

            var customPage = customLabels.find(function (customObj) {
                return customObj.page === page;
            });
            if (customPage && customPage.label) {
                return customPage.label;
            }
            if (showItemsRange) {
                return this.showItemsRange(page);
            }
            return null;
        }
    }, {
        key: 'createPageRange',
        value: function createPageRange() {
            var _props7 = this.props,
                totalPages = _props7.totalPages,
                pagerLength = _props7.pagerLength,
                offset = _props7.offset;

            var itemOffset = (0, _utils.clamp)(offset, 0, (0, _utils.clamp)(totalPages - pagerLength, 0, totalPages));
            var pagesCount = Math.min(totalPages, pagerLength);
            return (0, _utils.range)(pagesCount).map(function (x, index) {
                return index + itemOffset + 1;
            });
        }
    }, {
        key: 'showItemsRange',
        value: function showItemsRange(page) {
            var _props8 = this.props,
                pageSize = _props8.pageSize,
                totalPages = _props8.totalPages,
                totalItems = _props8.totalItems,
                itemsRangeOffset = _props8.itemsRangeOffset;


            var rangeStart = (page - 1) * pageSize + 1;
            if (itemsRangeOffset) {
                rangeStart += itemsRangeOffset - 1;
            }

            var rangeEnd = void 0;
            if (page !== totalPages) {
                rangeEnd = page * pageSize;
            } else {
                rangeEnd = totalItems;
            }

            if (itemsRangeOffset) {
                rangeEnd += itemsRangeOffset - 1;
            }

            if (rangeEnd === rangeStart) {
                return rangeStart;
            }

            return rangeStart + '-' + rangeEnd;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props9 = this.props,
                totalPages = _props9.totalPages,
                currentPage = _props9.currentPage,
                offset = _props9.offset,
                pagerLength = _props9.pagerLength,
                onPageChange = _props9.onPageChange,
                hideOnSinglePage = _props9.hideOnSinglePage;

            var pagerClassNames = (0, _classnames2.default)('ui-btnGroup', 'ui-btnGroup_pagination', 'rn-pagination');
            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)(pagerClassNames, { hidden: !totalPages || hideOnSinglePage && totalPages === 1 })
                },
                Pager.renderArrow(this.onNavigateLeftClick, offset <= 0, _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'Medium', iconName: 'expand-all', className: 'rotate_right' })),
                Pager.renderArrow(this.onLeftClick, currentPage <= 1, _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'Medium', iconName: 'left' })),
                _react2.default.createElement(
                    'span',
                    { className: 'ui-btn_paginationRange ui-btn' },
                    this.getCurrentPageLabel()
                ),
                this.createPageRange().map(function (page) {
                    return _react2.default.createElement(
                        _PageLink2.default,
                        {
                            active: currentPage === page,
                            onClick: function onClick() {
                                return onPageChange(page, _this2.props);
                            },
                            key: page,
                            'page-number': page
                        },
                        _this2.getPageLabel(page)
                    );
                }),
                Pager.renderArrow(this.onRightClick, currentPage >= totalPages, _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'Medium', iconName: 'right' })),
                Pager.renderArrow(this.onNavigateRightClick, offset >= totalPages - pagerLength, _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'Medium', iconName: 'expand-all', className: 'rotate_left' }))
            );
        }
    }]);

    return Pager;
}(_react.Component);

Pager.propTypes = {
    /**
     * On page change callback
     */
    onPageChange: _react2.default.PropTypes.func.isRequired,

    /**
     * On change offset callback
     */
    onOffsetChange: _react2.default.PropTypes.func,

    /**
     * Items per page
     */
    pageSize: _react2.default.PropTypes.number,

    /**
     * Number of displayed pages
     */
    pagerLength: _react2.default.PropTypes.number,

    /**
     * Number of pages scrolled by << and >> buttons
     */
    offsetRange: _react2.default.PropTypes.number,

    /**
     * Hide pager if there is only one page
     */
    hideOnSinglePage: _react2.default.PropTypes.bool,

    /**
     * Show items range instead of page numbers:
     * [1-50] [51-100] [101-142]
     */
    showItemsRange: _react2.default.PropTypes.bool,

    /**
     * Start items range from specific value:
     * [23-72] [73-122] [123-172]
     */
    itemsRangeOffset: _react2.default.PropTypes.number,

    /**
     * Provide custom labels for specific pages using next format:
     * [
     *    { page: 1, label: 'This' },
     *    { page: 2, label: 'is' },
     *    { page: 3, label: 'SPARTA' },
     * ]
     */
    customLabels: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
        page: _react2.default.PropTypes.number,
        label: _react2.default.PropTypes.string
    })),

    /**
     * State properties
     */
    stateKey: _react2.default.PropTypes.string,
    totalItems: _react2.default.PropTypes.number,
    totalPages: _react2.default.PropTypes.number,
    currentPage: _react2.default.PropTypes.number,
    offset: _react2.default.PropTypes.number
};

Pager.defaultProps = {
    showItemsRange: false,
    hideOnSinglePage: true,
    customLabels: []
};

function mapStateToProps(state, ownProps) {
    var pager = state[ownProps.stateKey].pager;

    return {
        totalPages: pager.totalPages,
        totalItems: pager.totalItems,
        currentPage: pager.currentPage,
        offset: pager.offset
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onOffsetChange: function onOffsetChange(offset, length) {
            return dispatch((0, _actions.pagerOffsetChange)(ownProps.stateKey, offset, length));
        }
    };
}

var PagerDefault = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Pager);

exports.default = Pager;
exports.PagerDefault = PagerDefault;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-pagination/lib/components/Pager.js
// module id = 1727
// module chunks = 1